export class Client {
    id?: number;
    firstName?: string;
    email?: string;
    phoneNumber?: string;
    lastName?: string;
    constructor(id?: number, firstName?: string, email?: string, phone?: string, lastName?: string) {
        this.id = id;
        this.lastName = lastName;
        this.email = email;
        this.phoneNumber = phone;
        this.firstName = firstName;
    }
}